import { render } from "./CreateNewPageModal.vue?vue&type=template&id=51c098e1"
import script from "./CreateNewPageModal.vue?vue&type=script&lang=js"
export * from "./CreateNewPageModal.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__